import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';

import { FacturaService } from 'services/FacturaService';
import { UnidadService } from 'services/UnidadService';
import { PagoService } from 'services/PagoService';

import useRequest from 'hooks/useRequest';
import { useStore, useStorePersist } from "store/context";

import MainLayout from 'components/Layouts/MainLayout';
import GradientButton from 'components/atoms/GradientButton'

import Facturacion from 'components/atoms/Facturacion';
import SearchSelect from 'components/atoms/SearchSelect';

import Modal from 'components/atoms/Modal';

import './styles.scss';

const ConsultaYDescargaView = (props) => {
    const history = useHistory();

    const {
        success, showSuccess, message, loadingSpinner, beforeSubmit, afterSubmit,
        dealWithError
    } = useRequest();

    const { id, external_reference, tipo_pago } = useParams();

    const [{
        uf,  // La uf actual seleccionada
        facturasLastUf,  // La uf a la que pertenecen las facturas cargadas
        facturas,  // El listado de facturas
    }, dispatch] = useStore();

    const [{
        unidades
    }, dispatchPersist] = useStorePersist();

    const [deudaSeleccionada, setDeudaSeleccionada] = useState(0.00);

    const titleDebito = <>
        <strong>UF</strong> {uf.unidad} - {uf.alias}
    </>;

    const [showMetodoPago, setShowMetodoPago] = useState(false);

    const PAGO_RECHAZADO = 0;
    const PAGO_EXITOSO = 1;
    const PAGO_PENDIENTE = 2;

    const [metodoPagoMensaje, setMetodoPagoMensaje] = useState();
    const [tituloMetodoPago, setTituloMetodoPago] = useState();

    const handleCloseMetodoPago = () => {
        setShowMetodoPago(false);
        //history.push('/consulta_descarga_facturas');
    }

    const bodyMetodoPago = <span className="confirmar-baja-body">
        <h3>{tituloMetodoPago}</h3>
        <div className="confirmar-baja-container">
            <div className="confirmar-baja-content baja-confirmar">

                {(success === false && message) &&
                    <p className="confirmar-baja-mensaje">{message}</p>
                }
                {(metodoPagoMensaje) &&
                    <p className="confirmar-baja-mensaje">{metodoPagoMensaje}</p>
                }

                <div className="confirmar-baja-button">
                    <GradientButton legend={'CERRAR'} handleClick={handleCloseMetodoPago} />
                </div>
            </div>
        </div>
    </span>;

    useEffect(() => {
        if (!unidades || unidades.length === 0) {
            getUnidades();
        }
        if (id && external_reference && tipo_pago == PAGO_EXITOSO) {
            beforeSubmit();
            PagoService.pagoExitoso(id, external_reference)
                .then(data => {
                    setTituloMetodoPago('PAGO ONLINE EXITOSO');
                    setMetodoPagoMensaje('Es posible que aún no se vea reflejado el pago');
                    dispatch({
                        type: 'setFacturas',
                        payload: [],
                    });
                    setShowMetodoPago(true);
                    afterSubmit();
                }).catch((error) => {
                    console.log('Error al marcar pago exitoso');
                    setShowMetodoPago(true);
                    dealWithError(error, '');
                });
        }

        if (id && external_reference && tipo_pago == PAGO_PENDIENTE) {
            beforeSubmit();
            PagoService.pagoPendiente(id, external_reference)
                .then(data => {
                    setTituloMetodoPago('PAGO ONLINE PENDIENTE');
                    setMetodoPagoMensaje('Es posible que aún no se vea reflejado el pago');
                    dispatch({
                        type: 'setFacturas',
                        payload: [],
                    });
                    setShowMetodoPago(true);
                    afterSubmit();
                }).catch((error) => {
                    console.log('Error al marcar pago pendiente');
                    setShowMetodoPago(true);
                    dealWithError(error, '');
                });
        }


        if (id && external_reference && tipo_pago == PAGO_RECHAZADO) {
            beforeSubmit();
            PagoService.pagoRechazado(id, external_reference)
                .then(data => {
                    setTituloMetodoPago('PAGO ONLINE RECHAZADO');
                    setMetodoPagoMensaje('Consultá otras opciones de pago en la Página Principal');
                    dispatch({
                        type: 'setFacturas',
                        payload: [],
                    });
                    setShowMetodoPago(true);
                    afterSubmit();
                }).catch((error) => {
                    console.log('Error al marcar pago rechazado');
                    setShowMetodoPago(true);
                    dealWithError(error, '');
                });
        }
    }, []);

    useEffect(() => {
        console.log('daaa');
        // Si facturasLastUf es null, siempre recargar (viene de HomeView o primera carga)
        // Si facturasLastUf tiene valor, solo recargar si es diferente UF
        if (!uf || (facturasLastUf && uf.id === facturasLastUf.id)) {
            return;
        }

        let fechaHoy = new Date();
        let hoy = formatDate(fechaHoy);
        fechaHoy.setFullYear(fechaHoy.getFullYear() + 1);
        let vto = formatDate(fechaHoy);
        const data = {
            fecha_emi: hoy,
            fecha_vto: vto,
        }
        beforeSubmit();
        FacturaService.comprobantes(uf.unidad, data)
            .then(data => {
                showSuccess('Comprobantes obtenidos');
                //data.reverse();
                dispatch({
                    type: 'setFacturas',
                    payload: data,
                });
                dispatch({
                    type: 'setFacturasLastUf',
                    payload: uf,
                });
            }).catch((error) => {
                console.log('No hay comprobantes');
                dispatch({
                    type: 'setFacturas',
                    payload: [],
                });
                dispatch({
                    type: 'setFacturasLastUf',
                    payload: {},
                });
                dealWithError(error, 'Error al obtener comprobantes');
            });
    }, [uf]);

    const handleChange = (uf) => {
        const filtrada = unidades.find(filtrada => filtrada.unidad === uf);
        dispatch({
            type: 'setUf',
            payload: filtrada,
        });
        setDeudaSeleccionada(0.00);
    };

    useEffect(() => {
        console.log('efect unidades');
        if (unidades && unidades.length > 0 && !uf) {
            if (id && external_reference) {
                UnidadService.unidad(id)
                    .then((unidad) => {
                        dispatch({
                            type: 'setUf',
                            payload: unidad,
                        });
                    }).catch((error) => {
                        dealWithError(error, 'Error al obtener la unidad');
                    });
            } else {
                dispatch({
                    type: 'setUf',
                    payload: unidades[0],
                });
            }
        }
    }, [unidades]);

    const getUnidades = () => {
        beforeSubmit();
        UnidadService.unidades({})
            .then((unidades) => {
                afterSubmit();
                if (unidades.length === 0) {
                    history.push('/unidades_adheridas');
                    return;
                }

                dispatchPersist({
                    type: 'setUnidades',
                    payload: unidades
                });
            }).catch((error) => {
            });
    }


    const handleCheckChieldElement = (event, monto) => {
        facturas.forEach(factura => {
            if (factura.comprobante === event.target.value) {

                if (event.target.checked) {
                    factura.isChecked = event.target.checked
                    setDeudaSeleccionada(parseFloat(deudaSeleccionada) + monto);
                } else {
                    factura.isChecked = event.target.checked
                    setDeudaSeleccionada(parseFloat(deudaSeleccionada) - monto);
                }
            }
        })

        dispatch({
            type: 'setFacturas',
            payload: facturas,
        });
    }

    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }

    return (
        <>
            <MainLayout>
                {unidades && <SearchSelect onChange={handleChange} options={unidades} value={uf}></SearchSelect>}
                <Facturacion setDeudaSeleccionada={setDeudaSeleccionada} loadingSpinner={loadingSpinner} deudaSeleccionada={deudaSeleccionada} facturas={facturas} unidad={uf} handleCheckbox={handleCheckChieldElement}></Facturacion>
            </MainLayout>
            <Modal className="modal-debito-automatico" title={titleDebito} body={bodyMetodoPago} legend={""} handleClose={handleCloseMetodoPago} show={showMetodoPago}></Modal>
        </>
    );
}

export default withTranslation()(ConsultaYDescargaView);
